import { QuizSession } from "./QuizSession";
import { CookieStorage } from "../CookieStorage";
import { uuidGenerator } from "@/helpers/uuidGenerator";

let instance = null;

export class QuizSessionFactory {
  static getInstance() {
    if (!instance) {
      const storage = new CookieStorage();
      const quizSession = new QuizSession(storage, uuidGenerator);
      instance = quizSession;
    }

    return instance;
  }
}
